import { accessTypeEnum } from './../../lib/enum';

const addAccessRight = [
  accessTypeEnum.admin,
  accessTypeEnum.handlingOsagoMultipliers
];

export default addAccessRight;
